import { useLatest } from '@sgcmpteltd/uikit-react';
import { useEffect, useState } from 'react';
import { safeParse } from 'valibot';

import type { Hook } from './types';

export const useWindowMessageListen: Hook = ({
  schema,
  onTrigger,
}) => {
  const { ref: schemaLatestRef } = useLatest({
    value: schema,
  });
  const { ref: onTriggerLatestRef } = useLatest({
    value: onTrigger,
  });
  const [isMessageListening, setIsMessageListening] = useState(false);

  useEffect(() => {
    const { current: schemaLatest } = schemaLatestRef;
    const { current: onTriggerLatest } = onTriggerLatestRef;

    if (!schemaLatest || !onTriggerLatest) {
      return undefined;
    }

    const onWindowMessage: Window['onmessage'] = ({
      data,
    }) => {
      const { success, output } = safeParse(schemaLatest, data);

      if (!success) {
        return;
      }

      onTriggerLatest(output);
    };

    window.addEventListener('message', onWindowMessage);

    setIsMessageListening(true);

    return () => {
      window.removeEventListener('message', onWindowMessage);
    };
  }, [
    schemaLatestRef,
    onTriggerLatestRef,
  ]);

  return {
    isMessageListening,
  };
};
